<app-login-layout class="login">
	<form [formGroup]="authForm" (ngSubmit)="onLogin()">
		<h1>Two-Factor Recovery</h1>
		<p>
			You have requested to log in with a recovery code. This login will not be remembered until you provide an
			authentication code at log in or disable 2FA and log in again.
		</p>
		<app-input-field
			label="Recovery Code"
			[control]="authForm.get('recoveryCode')"
			name="code"
			icon="pin"
			autocomplete="off"
			placeholder="8-digit code"
		>
		</app-input-field>
		<div *ngIf="authForm.errors && authForm.errors.invalidAuthCode" class="login-error">
			The recovery code you entered is invalid. Please try another.
		</div>
		<div class="login-actions">
			<div class="links">
				<a [routerLink]="['/login']">Cancel</a>
			</div>
			<mat-spinner *ngIf="loading" diameter="20"></mat-spinner>
			<button type="submit" mat-flat-button color="primary" [disabled]="authForm.invalid || loading">
				Sign in
			</button>
		</div>
	</form>
</app-login-layout>
